import { Controller } from "@hotwired/stimulus"

// Grower directory toolbar. Search and the has-access chips drive the
// SERVER-SIDE (Pagy) results, which live in the "growers" Turbo Frame. We
// navigate by re-pointing the frame's src at the paginated index and keep the
// browser URL in sync, so the in-frame sort/pager links carry the current
// query and refresh / back-button work. The search input sits outside the
// frame, so it keeps focus while typing.
export default class extends Controller {
  static targets = ["query", "frame", "chip"]

  DEBOUNCE_MS = 250

  disconnect() {
    clearTimeout(this.timer)
  }

  // Debounced live search.
  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.navigate({ q: this.queryTarget.value, page: null }), this.DEBOUNCE_MS)
  }

  // Has-access filter chip. Toggle the active style locally (the chips live
  // outside the frame, so the server doesn't re-render them) and navigate.
  setAccess(event) {
    const access = event.currentTarget.dataset.access || "all"
    this.chipTargets.forEach((chip) => {
      const active = (chip.dataset.access || "all") === access
      chip.classList.toggle("btn-primary", active)
      chip.classList.toggle("btn-outline", !active)
    })
    this.navigate({ access: access === "all" ? null : access, page: null })
  }

  // Merge changes into the current URL, reload the results frame, and sync the
  // browser URL. A null/"" value drops the param.
  navigate(changes) {
    const url = new URL(window.location)
    for (const [key, value] of Object.entries(changes)) {
      if (value === null || value === "") url.searchParams.delete(key)
      else url.searchParams.set(key, value)
    }
    this.frameTarget.src = url.pathname + url.search
    history.replaceState(history.state, "", url)
  }
}
